import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Download, Eye, X } from "lucide-react";

const fetchBlob = (name) => api.get(`/system-health/release-artifacts/${encodeURIComponent(name)}`, { responseType: "blob" }).then((r) => r.data);

export const ReleaseArtifacts = () => {
  const [items, setItems] = useState([]);
  const [view, setView] = useState(null);
  useEffect(() => { api.get("/system-health/release-artifacts").then((r) => setItems(r.data.items)).catch(() => setItems([])); }, []);

  const download = async (name) => {
    try {
      const url = URL.createObjectURL(await fetchBlob(name));
      const a = Object.assign(document.createElement("a"), { href: url, download: name });
      a.click(); setTimeout(() => URL.revokeObjectURL(url), 2000);
    } catch { toast.error("Download failed"); }
  };
  const open = async (name) => {
    try { setView({ name, text: await (await fetchBlob(name)).text() }); } catch { toast.error("Could not open artifact"); }
  };

  if (!items.length) return null;
  return (
    <div className="os-card p-4" data-testid="release-artifacts-card">
      <b className="text-[11px] uppercase tracking-[0.14em] text-[color:var(--st-text-subtle)]">Release artifacts · super admin only</b>
      <ul className="mt-2 divide-y divide-[color:var(--st-border)]">
        {items.map((it) => (
          <li key={it.name} className="flex items-center gap-2 py-2 text-[12px]" data-testid={`release-artifact-${it.name}`}>
            <span className="font-mono flex-1 truncate">{it.name}</span>
            <span className="text-[color:var(--st-text-muted)]">{(it.bytes / 1024).toFixed(1)} KB</span>
            {it.text && <button onClick={() => open(it.name)} className="h-8 px-3 rounded-full border border-[color:var(--st-border)] inline-flex items-center gap-1" data-testid={`release-artifact-view-${it.name}`}><Eye className="h-3.5 w-3.5" /> View</button>}
            <button onClick={() => download(it.name)} className="h-8 px-3 rounded-full bg-[color:var(--st-text)] text-white inline-flex items-center gap-1" data-testid={`release-artifact-download-${it.name}`}><Download className="h-3.5 w-3.5" /> Download</button>
          </li>
        ))}
      </ul>
      {view && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" data-testid="release-artifact-viewer">
          <div className="bg-white rounded-xl w-full max-w-4xl max-h-[85vh] flex flex-col">
            <div className="flex items-center p-3 border-b"><b className="font-mono text-[12px] flex-1">{view.name}</b>
              <button onClick={() => setView(null)} data-testid="release-artifact-viewer-close"><X className="h-4 w-4" /></button></div>
            <pre className="p-3 overflow-auto text-[11px] whitespace-pre-wrap" data-testid="release-artifact-viewer-text">{view.text}</pre>
          </div>
        </div>
      )}
    </div>
  );
};
